module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gray-back",
    staticStyle: {
      "padding": ".2rem 0 1rem 0"
    }
  }, [_c('van-cell-group', [_c('van-cell', {
    attrs: {
      "title": "省市",
      "value": _vm.row.county ? _vm.row.province + '/' + _vm.row.city + '/' + _vm.row.county : ''
    }
  }), _vm._v(" "), _c('van-cell', {
    attrs: {
      "title": "领取单位",
      "value": _vm.row.danwei
    }
  }), _vm._v(" "), _c('van-cell', {
    attrs: {
      "title": "年份",
      "value": _vm.row.year
    }
  }), _vm._v(" "), _c('van-cell', {
    attrs: {
      "title": "联系人姓名",
      "value": _vm.row.name
    }
  }), _vm._v(" "), _c('van-cell', {
    attrs: {
      "title": "联系人手机",
      "value": _vm.row.phone
    }
  }), _vm._v(" "), _c('van-cell', {
    attrs: {
      "title": "领取时间",
      "value": _vm.row.getdate
    }
  })], 1), _vm._v(" "), _c('van-divider', [_vm._v("审核信息")]), _vm._v(" "), _c('van-cell', {
    attrs: {
      "title": "备案审核"
    }
  }, [(_vm.row.status == 0) ? _c('div', [_vm._v("未提交")]) : (_vm.row.status == 1) ? _c('div', [_vm._v("待审核")]) : (_vm.row.status == 2) ? _c('div', [_vm._v("审核通过")]) : (_vm.row.status == 3) ? _c('div', [_vm._v("审核失败")]) : _vm._e()]), _vm._v(" "), _c('van-cell', {
    attrs: {
      "title": "管理员备注",
      "value": _vm.row.adminnote
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4db1c19f","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/weiyuanhui/apps/sihao/SihaoDetail.vue
// module id = 2361
// module chunks = 0